module.exports = __webpack_public_path__ + "static/media/figma.820f3f3b.svg";